import React, { useEffect } from 'react';
import BlogData from '../component/blog-data';
import Wrapper from "../component/Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { selectEnterprisesData } from "../store/selectors";
import { getEnterprisesData } from "../store/actions/app";
import { useLocalizedData } from '../hooks/useTranslatedContent';
import Preloader from "../component/Preloader";
import Error404 from "../component/404";

export default function Blogs() {
    const dispatch = useDispatch();
    const enterprisesData = useSelector(selectEnterprisesData);
    const status = useSelector(state => state.app.status.enterprisesData);
    const { getLocalizedFirstItem } = useLocalizedData(enterprisesData);

    useEffect(() => {
        if (status === 'idle') dispatch(getEnterprisesData());
    }, [dispatch, status]);

    if (status === 'loading' || status === 'idle') {
        return (
            <Preloader/>
        );
    }

    if (status === 'failed' || !enterprisesData) {
        return <Error404 />;
    }
    const bannerItem = getLocalizedFirstItem('enterprisesPageBanner');

    return (
        <Wrapper>
            <section
                className="relative w-full bg-no-repeat bg-cover bg-center"
                id="home"
                style={{ backgroundImage: `url(${bannerItem.img})` }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60 z-0"></div>

                <div className="relative z-10 container mx-auto px-4 py-24 md:py-32 text-left flex flex-col justify-center items-start min-h-[60vh]">
                    {bannerItem.description && (
                        <div className="max-w-4xl">
                            <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
                                {bannerItem.titleBanner}
                            </h1>
                            <p
                                className="text-white text-base sm:text-lg md:text-xl mt-4"
                                dangerouslySetInnerHTML={{ __html: bannerItem.description }}
                            />
                        </div>
                    )}
                </div>
            </section>

            <section className="relative md:py-24 py-16" id="blog">
                <BlogData enterprisesData={enterprisesData} />
            </section>
        </Wrapper>
    );
}